import { useAppStore } from '@/stores/app'
import type { IMaintenance } from '../interfaces/seigyo-config'
import { useMaintenanceStore } from '@/stores/maintenance'
import seigyoConfig from '../utils/seigyo-config'
import { fetchMPCMaintenanceConfig } from '@/api/eiko-profile'
import getMceUrlByCountry from '../utils/get-mce-url-by-country'
import { maintenanceMiddleware } from '@npm/seigyo-maintenance-mode'

import type {
  NavigationGuardNext,
  RouteLocationNormalizedGeneric,
  RouteLocationNormalizedLoadedGeneric
} from 'vue-router'
import { useChannels } from './useChannels'

export const useMaintenanceSetup = () => {
  const appStore = useAppStore()
  const maintenanceStore = useMaintenanceStore()
  const { isMCWebChannel, isChatbotChannel, isMCAppChannel } = useChannels()

  const setMaintenance = async (
    to: RouteLocationNormalizedGeneric,
    from: RouteLocationNormalizedLoadedGeneric,
    next: NavigationGuardNext
  ) => {
    const responseSeigyo = await seigyoConfig()
    if (!isMCWebChannel.value) {
      setMaintenanceMCE(responseSeigyo.Maintenance)
      if (!isMCAppChannel.value) {
        setMaintenanceMPC()
      }
    }
    maintenanceMiddleware(to, from, next, responseSeigyo, isMCE())
  }

  const setMaintenanceMCE = async (maintenance: any) => {
    const maintenanceMCE = maintenance.find(
      (maintenance: IMaintenance) => maintenance.Name === appStore.country.toUpperCase()
    )
    maintenanceStore.setMaintenance(maintenanceMCE)
  }

  const setMaintenanceMPC = async () => {
    const { Maintenance: maintenanceCountryMPC } = await fetchMPCMaintenanceConfig(
      getMceUrlByCountry(appStore.country)!
    )
    const maintenanceMPC = maintenanceCountryMPC.find(
      (maintenance: IMaintenance) => maintenance.Name === appStore.country.toUpperCase()
    )
    maintenanceStore.setMaintenanceMPC(maintenanceMPC!)
  }

  const isMCE = () => {
    const channels = [isMCWebChannel.value, isChatbotChannel.value, isMCAppChannel.value]
    const isDiferentToMCE = channels.filter((channel) => channel === true)
    return isDiferentToMCE.length === 0 ? true : false
  }

  return {
    setMaintenanceMPC,
    setMaintenance
  }
}
